import { useMutation } from '@tanstack/react-query';

export default function useReadCandidateChatMessages() {
  // CSRF meta が無い環境でもクラッシュしないよう、安全に取得する
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
  return useMutation({
    mutationFn: async (candidateProfileId: number) => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_chat_messages/read`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
        }
      );
      // 4xx/5xx でも fetch は reject しないため、明示的に ok を確認して失敗を伝播する
      if (!response.ok) {
        throw new Error('既読化に失敗しました');
      }
      const data = await response.json();
      return data;
    },
  });
}
